import Vue from 'vue'
import Router from 'vue-router'
import home from './home'
import edit from './edit'

// 解决vue-router重复点击报错问题（this.$router.replace()）
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
// 解决vue-router重复点击报错问题（this.$router.push()）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/home',
    component: () => import('@/views/Container/Container'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    children: [...home]
  },
  {
    path: '/edit',
    name: 'Edit',
    component: () => import('@/views/Edit/Edit'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    children: [...edit]
  }
]

export function createRouter() {
  return new Router({
    mode: 'history',
    routes
  })
}
